import { computed } from "vue";
import { useAuthStore } from "../AuthStore/useAuthStore";
import { useAppMutation } from "../Mutation/useHydraMutations";
import { useNotificationsV2 } from "./useNotificationsV2";
import { markNotificationAsReadMutation, userNotificationsCollectionUrl } from "./v2/notifications.api";

/**
 * Resolves the current user's notification endpoints for the active notification system:
 * the v2 inbox when `notificationsV2Enabled` is set, otherwise the legacy notifications.
 */
export function useNotificationEndpoints() {
  const authStore = useAuthStore();
  const { isV2Enabled } = useNotificationsV2();
  const markAsReadMutation = useAppMutation(markNotificationAsReadMutation());

  const collectionEndpoint = computed(() => {
    const userId = authStore.user.value?.id;
    if (!userId) {
      return "";
    }

    return isV2Enabled.value
      ? userNotificationsCollectionUrl(userId)
      : `/users/${userId}/legacy_notifications`;
  });

  /** Marks a v2 user notification or a legacy notification read; the active notification system decides by default. */
  function markAsRead(notificationId: number, readAt: string, isUserNotification: boolean = isV2Enabled.value) {
    return markAsReadMutation.mutateAsync({
      notificationId,
      readAt,
      isV2: isUserNotification,
    });
  }

  return {
    isV2Enabled,
    collectionEndpoint,
    markAsRead,
  };
}
